export function authHeader() {
    // return authorization header with basic auth credentials
    // Check both localStorage (remember me) and sessionStorage (current session)
    const userStorage = localStorage.getItem('user') || sessionStorage.getItem('user');
    let user = userStorage ? JSON.parse(userStorage) : null;

    if (user && user.authdata) {
        return { 'Authorization': 'Basic ' + user.authdata };
    } else {
        return {};
    }
}